module.exports = __webpack_public_path__ + "static/img/Fajgel-Loreen.c47f2d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Fajgel-Loreen.jpg
// module id = +XwG
// module chunks = 1